{
  "hero": {
    "title": "Getting Started",
    "description": "Split into three role-based sections, walking through the platform's actual operations step by step. For a quick overview of what the platform is first, see the about page."
  },
  "roleNav": {
    "label": "Choose a role"
  },
  "step": "STEP {{number}}",
  "roles": {
    "student": {
      "title": "Participant",
      "description": "The full flow from registration to seeing your results.",
      "manualCta": "NAPAICP Participant Guide",
      "steps": {
        "signIn": {
          "title": "Register or sign in",
          "description": "Register with an email address and verify it; after that you can sign in with your password."
        },
        "team": {
          "title": "Create or join a team",
          "description": "Start your own team, or use an invite link from a team leader to join an existing one; you can only belong to one team per competition."
        },
        "form": {
          "title": "Fill out the registration & submission forms",
          "description": "Fill in the fields the competition defines. The registration form saves automatically; once every required field is filled in and saved, your registration counts as submitted and you can keep editing it until the deadline; if it later shows \"Needs update\", fill in the missing fields. A submission form is different: it is saved as a draft, and after checking it you mark it ready and formally submit it."
        },
        "submit": {
          "title": "Upload and formally submit your work",
          "description": "Files upload directly to private storage via a short-lived signed link. Once you're satisfied, submit for real; the submitted version is frozen and can no longer be edited in place."
        },
        "results": {
          "title": "Track scoring and results",
          "description": "Once results are published you can see your score and ranking on your team's page; if the competition has a final round, advancement is announced here too."
        },
        "events": {
          "title": "Use event services (optional)",
          "description": "When you attend a conference or other event, open Events in the main navigation: book the free shuttle with just an email (up to 3 companions) and get a ride QR, reply about lunch and the banquet, and send cases to the help desk. See Event services in the Participant Guide."
        }
      }
    },
    "judge": {
      "title": "Judge",
      "description": "The full flow from reviewing assignments to submitting scores.",
      "manualCta": "NAPAICP Judge Guide",
      "steps": {
        "signIn": {
          "title": "Sign in with your judge account",
          "description": "The organizer invites you by email: if that address already has an account, sign in and press \"Accept invitation\" (or \"Decline\") under \"Judge invitations waiting for your answer\" on your Overview page to become a judge; if not, an account is created automatically and a one-time temporary password is emailed to you, and you'll be required to set a new password on first login."
        },
        "assignments": {
          "title": "Review your assignment list",
          "description": "Assignments show only an anonymous code for each submission, never the team's or participant's real identity, so scoring stays fair."
        },
        "score": {
          "title": "Score against the rubric",
          "description": "Score every rubric item the organizer defined, each within its allowed range."
        },
        "submitScore": {
          "title": "Submit your score",
          "description": "Once every item is complete, submit. A submitted score is locked; the organizer has to reopen it before you can change it."
        },
        "events": {
          "title": "Event services are separate from judging (optional)",
          "description": "Shuttle, meals and the help desk on event pages need only a signed-in account with a verified email, do not affect your judge role or scoring, and event data is stored apart from competition scoring data."
        }
      }
    },
    "admin": {
      "title": "Organizer",
      "description": "The full flow from creating a competition to publishing results.",
      "manualCta": "NAPAICP Organizer Guide",
      "steps": {
        "createCompetition": {
          "title": "Create the competition and set its schedule",
          "description": "Use the competition builder to set registration, submission, and judging windows; competitions with a preliminary and final round can configure both stages."
        },
        "formsCategories": {
          "title": "Design forms and categories",
          "description": "Build the registration and submission forms and set up entry categories as needed; published form versions keep their history."
        },
        "rubricJudges": {
          "title": "Build a rubric and assign judges",
          "description": "Design scoring items and weights, assign judge accounts to the right submissions, and set conflict-of-interest exclusions as needed."
        },
        "calculateResults": {
          "title": "Calculate, lock, and publish results",
          "description": "Once scoring is done, calculate results, manually review award tiers if needed, then lock and publish; every adjustment is recorded for audit."
        },
        "announce": {
          "title": "Announce and notify participants",
          "description": "Publish an announcement on the Announcements page in the Operations group of the admin console; it shows on the public page and on participants' Competition Information page. When needed, tick \"Also notify by email\" and choose recipients by role, category, round or registration field. Before sending, the page shows the count and an email preview, and you can first send a test to yourself; sent email cannot be recalled."
        },
        "events": {
          "title": "Run an event on site (optional)",
          "description": "Event Owners manage members (Owner, Manager, Scanner, Viewer) at /events/:slug/admin; on site, staff scan ride QR codes on the shuttle check-in page, can queue scans offline and sync later, and cross-check the passenger list. Competition organizer permissions do not become event permissions."
        }
      }
    }
  },
  "helpCenterCta": {
    "heading": "Looking for something specific?",
    "description": "Head to the Help Center to search by keyword and find your answer fast."
  },
  "cta": {
    "heading": "Ready to get started?",
    "description": "Sign in and the platform will take you to the area that matches your role.",
    "action": "Sign in",
    "aboutCta": "About the platform",
    "architectureCta": "Technical architecture"
  },
  "adminGuide": {
    "heading": "Platform administrator?",
    "description": "See the full NAPAICP Platform Administration Guide, with step-by-step coverage of the platform and competition admin interfaces.",
    "action": "NAPAICP Platform Administration Guide"
  },
  "manuals": {
    "heading": "Full guides",
    "description": "The complete operating manual for each role:",
    "student": "NAPAICP Participant Guide",
    "judge": "NAPAICP Judge Guide",
    "organizer": "NAPAICP Organizer Guide",
    "admin": "NAPAICP Platform Administration Guide"
  }
}
